<mat-progress-bar
  mode="determinate"
  class="rounded-[0.625rem]"
  [value]="fillPercentage()"
  [color]="color()"
></mat-progress-bar>
